/**
 * Is a first decision on this paper allowed yet?
 *
 * Client-side mirror of the enforce_decision_readiness trigger
 * (migration 20261017130000) — the trigger is the authority; this exists so
 * the UI can grey out decision buttons and say why, instead of letting the
 * chair click and then showing them a database error.
 *
 * Keep the two in sync: after the submission deadline every paper can be
 * decided; before it, only a paper whose assigned reviews are all submitted.
 * Papers already decided aren't gated.
 *
 * @returns {null | { reason: 'reviews', done: number, total: number, until: Date }
 *                 | { reason: 'deadline', until: Date }}
 */
export function getDecisionLock(paper, conference, now = new Date()) {
  if (paper?.status === 'accepted' || paper?.status === 'rejected') return null;

  const until = conference?.paperDeadline ? new Date(conference.paperDeadline) : null;
  if (!until || now >= until) return null;

  const reviewers = paper?.reviewers || [];
  if (reviewers.length > 0) {
    const done = reviewers.filter((r) => r?.reviewStatus === 'completed').length;
    if (done >= reviewers.length) return null;
    return { reason: 'reviews', done, total: reviewers.length, until };
  }

  return { reason: 'deadline', until };
}
